
export default function Hero() {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center pt-20"
      style={{
        background: 'linear-gradient(180deg, #F5F4F9 0%, #FFFFFF 100%)'
      }}
    >
      <div className="max-w-7xl mx-auto px-6 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6 pl-0 lg:pl-8">
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              Modern{' '}
              <span
                className="bg-gradient-to-r from-blue-500 to-purple-600 bg-clip-text text-transparent"
              >
                iOS
              </span>{' '}
              Applications
            </h1>
            <p className="text-2xl font-light text-gray-700">
              Expert team developing secure mobile solutions
            </p>
            <p className="text-base text-gray-600 leading-relaxed max-w-xl">
              ANOKEM d.o.o. is a team of experts developing modern applications for the iOS platform. Our products, such as VPN and Cleaner, are designed to enhance user experience and improve the security of mobile devices.
            </p>
          </div>

          <div className="flex justify-center lg:justify-end">
            <div
              className="relative rounded-3xl p-8 shadow-2xl"
              style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                width: '100%',
                maxWidth: '500px',
                aspectRatio: '1/1'
              }}
            >
              <div className="absolute inset-0 rounded-3xl overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/05d4230db14154c5ed5a91fc52562aad.jpg"
                  alt="iOS Applications"
                  className="w-full h-full object-cover opacity-90"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
